/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */


import Page from '../screens/page';
import Notfound from '../screens/notfound';
import HomePrintService from '../screens/homeprintservice';

const printserviceRoutes = [
  {
    path: '/login',
    component: Notfound,
    isPrivate: false,
  },
  {
    path: '/:page',
    component: Page,
    isPrivate: false,
  },
  {
    path: '/',
    component: HomePrintService,
    isPrivate: false,
  }
];

export default printserviceRoutes;
